import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/Crystal_Wedding_Logo_Primary_v2.svg'
import _imports_1 from '@/assets/images/unnamed1.jpg'


const _withScopeId = n => (_pushScopeId("data-v-0be2c974"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col min-h-screen justify-between" }
const _hoisted_2 = { class: "flex h-full" }
const _hoisted_3 = { class: "flex flex-1 flex-col py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24" }
const _hoisted_4 = { class: "mx-auto w-full max-w-sm lg:w-96" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2 content-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Heartful Logo",
    class: "flex h-64 w-64 mx-auto"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "relative hidden w-0 flex-1 min-h-screen lg:block overflow-hidden" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Heartful Logo",
    class: "w-full h-full absolute inset-0 object-cover"
  })
], -1))

import LoginForm from './components/LoginForm.vue'
	import ResetPasswordForm from './components/ResetPasswordForm.vue'
	import ResetPasswordSuccess from './components/ResetPasswordSuccess.vue'
	import UpdatePasswordForm from './components/UpdatePasswordForm.vue'

	import {
		useRoute,
		useRouter
	} from 'vue-router'

	import { 
		store as _userStore
	} from '@/store/user'

	import {
		computed,
		onBeforeMount
	} from 'vue'

	
	const __default__ = { name: 'LoginMain' } 	// name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const router = useRouter()
	const userStore = _userStore()

	const currentRoute = computed(() => {
		return useRoute().name
	})

	onBeforeMount(async () => {
		try {
			// check for existing login & reroute
			if(userStore.user.loggedIn && !userStore.user.isPasswordChangeNeeded) {
				router.push({name: "Jobs"})
			}
		}
		catch(e) {
			console.log(e)
		}
	})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          (currentRoute.value == 'Login')
            ? (_openBlock(), _createBlock(LoginForm, { key: 0 }))
            : (currentRoute.value == 'ResetPassword')
              ? (_openBlock(), _createBlock(ResetPasswordForm, { key: 1 }))
              : (currentRoute.value == 'ResetPasswordSuccess')
                ? (_openBlock(), _createBlock(ResetPasswordSuccess, { key: 2 }))
                : (currentRoute.value == 'UpdatePassword')
                  ? (_openBlock(), _createBlock(UpdatePasswordForm, { key: 3 }))
                  : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_6
    ])
  ]))
}
}

})